import UFooter from './UFooter'

export default UFooter;
